module.exports = __webpack_public_path__ + "static/media/wind_gust_3.bcf24ed7.png";